import { render } from "./Promotion6plus1View.vue?vue&type=template&id=0ad4e43e&scoped=true"
import script from "./Promotion6plus1View.vue?vue&type=script&lang=js"
export * from "./Promotion6plus1View.vue?vue&type=script&lang=js"

import "./Promotion6plus1View.vue?vue&type=style&index=0&id=0ad4e43e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad4e43e"]])

export default __exports__